export const BYNDER_URL_START = 'https://look.ams-osram.com/';
export const BYNDER_CHINA_URL_START = 'https://look.ams-osram.cn/';
export const LOCAL_URL_START = '/documents/';

const HEIGHT_PATTERN = new RegExp('height(:|%3A)([0-9]+)');
const WIDTH_PATTERN = new RegExp('width(:|%3A)([0-9]+)');

/**
 * @param {String} url
 * @param {Number} width
 * @returns String
 */
export default function getOptimizedImageUrl(url, width) {
    if (url.startsWith(BYNDER_URL_START)) {
        return getOptimizedAssetUrl(getBynderUrl(url, width));
    }

    return url;
}

/**
 * @param {String} url
 * @param locale
 * @returns String
 */
export function getOptimizedAssetUrl(url, locale = document.documentElement.lang) {
    return locale.startsWith("zh") ? url.replace(BYNDER_URL_START, BYNDER_CHINA_URL_START) : url;
}

/**
 * @param {String} url
 * @param {Number} width
 * @returns String
 */
export function getBynderUrl(url, width) {
    if (url.includes('?')) {
        // matches transform:fill and fit
        if (url.includes('io=transform:fi') || url.includes('io=transform%3Afi')) {
            url = replaceBynderParameters(url, width);
        } else {
            url = `${url}&io=transform:fill,width:${width}`;
        }
    } else {
        url = `${url}?io=transform:fill,width:${width}`;
    }

    return url;
}

/**
 * @param {String} url
 * @param {Number} newWidth
 * @returns String
 */
function replaceBynderParameters(url, newWidth) {
    let theight = 0;
    let twidth = 0;
    let newHeight = 0;

    const heightMatcher = HEIGHT_PATTERN.exec(url);
    if (heightMatcher !== null && heightMatcher.length === 2) {
        theight = parseInt(heightMatcher[2]);
    }

    const widthMatcher = WIDTH_PATTERN.exec(url);
    if (widthMatcher !== null && widthMatcher.length === 2) {
        twidth = parseInt(widthMatcher[2]);
    }

    if (twidth !== 0 && theight !== 0) {
        const ratio = twidth / theight;
        newHeight = Math.round(newWidth / ratio);
    }

    if (twidth !== 0) {
        url = url.replace('width:' + twidth, `width:${newWidth}`);
        url = url.replace('width%3A' + twidth, `width%3A${newWidth}`);
    }

    if (newHeight !== 0) {
        url = url.replace('height:' + theight, `height:${newHeight}`);
        url = url.replace('height%3A' + theight, `height%3A${newHeight}`);
    }

    return url;
}

/**
 * @param {String} url
 * @param {Number} width
 * @returns String
 */
export function getImageOptimizerUrl(url, width) {
    return `/o/imageoptim/convertWebP${url}/${width}`;
}
